import { getApp, getApps, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { firebaseConfig } from '@/utils/constants/firebase';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { currentRegion } from '@/lib/region';

const HOME_FUNCTIONS = { functionsRegion: process.env.NEXT_PUBLIC_FUNCTION_REGION || 'us-central1' };

const app = getApps()?.length ? getApp() : initializeApp(firebaseConfig);

export const auth = getAuth(app);

// Initialize App Check (client-side only)
if (typeof window !== 'undefined') {
    initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider(process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY),
        isTokenAutoRefreshEnabled: true,
    });
}

/** Same Auth instance as callables / MainLayout — do not re-initializeApp (throws if default app exists). */
export function useFirebaseAuth() {
    return auth;
}

/** Global data (countries, masterCountries, otpConfig) — always the home (default) database. */
export const homeFirestore = getFirestore(app);

// Regional data (customers, carts, orders, companies, …) for the region this page load runs in
// (see lib/region.js). With no region selected the app renders only RegionGate, so these are never used;
// they fall back to the home instances only so the modules importing them can load.
export const firestore = currentRegion?.databaseId ? getFirestore(app, currentRegion.databaseId) : homeFirestore;
export const functions = getFunctions(app, (currentRegion || HOME_FUNCTIONS).functionsRegion);
